import { FC } from 'react';
import type { File as ApiFile } from '@teachur/http-client';
import { File, Eye, Download } from 'lucide-react';
import { ProjectDrawerSection } from './ProjectDrawerSection';

interface ProjectFileProps {
  file?: ApiFile | null;
  onOpenFilePreview?: () => void;
}

export const ProjectFile: FC<ProjectFileProps> = ({ file, onOpenFilePreview }) => {
  const projectFileName = file?.pid ?? 'Project file';

  return (
    <ProjectDrawerSection title="Project Files">
      {file ? (
        <div className="flex items-center justify-between rounded-[10px] bg-(--neutral-black-NB100) px-3 py-3">
          <div className="flex items-center justify-center gap-1.5">
            <File className="text-(--neutral-black-NB500) w-4 h-4" />
            <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB900)! m-0!">
              {projectFileName}
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={onOpenFilePreview}
              className="flex items-center gap-1.5 [font-size:var(--fs-l5)]! font-medium text-(--primary-O1000)! cursor-pointer hover:text-(--primary-O1100)! transition-colors bg-transparent border-0 p-0"
            >
              <Eye className="w-4 h-4" />
            </button>
            <a
              href={file?.url}
              download={projectFileName}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-1.5 [font-size:var(--fs-l5)]! font-medium text-(--primary-O1000)! cursor-pointer hover:text-(--primary-O1100)! transition-colors no-underline!"
            >
              <Download className="w-4 h-4" />
            </a>
          </div>
        </div>
      ) : (
        <div className="rounded-[10px] bg-(--neutral-white-NW900) px-3 py-3">
          <p className="m-0! [font-size:var(--fs-p5)]! text-(--neutral-black-NB500)!">
            No files uploaded.
          </p>
        </div>
      )}
    </ProjectDrawerSection>
  );
};
